import React from 'react'
import * as Displays from 'support/displays'

export function FieldLabel () {
  return (
    <div className='flex items-center'>
      <div className='group space-y-1 whitespace-normal'>
        <div className='font-medium'>
          <Displays.Text name='label' />
        </div>
        <div className='text-sm'>
          <Displays.Text name='description' />
        </div>
      </div>
    </div>
  )
}

export default FieldLabel
